import { Alert, Cell, Grid } from 'bold-ui'
import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { Breadcrumb } from 'components/breadcrumb'
import { PageContent } from 'components/layout/PageContent'
import { TitleGroup } from 'components/TitleGroup'
import { css } from 'emotion'
import { Maybe, TipoGrupoParticipanteAtividadeColetivaEnum } from 'graphql/types.generated'
import React, { Fragment } from 'react'

import { AtividadeColetivaGruposForm } from './AtividadeColetivaGruposForm'
import { useAtividadeColetivaGruposCache } from './hooks/useAtividadeColetivaGruposCache'
import { AtividadeColetivaGruposFormModel } from './model-atividadeColetivaGrupos'

const atividadeColetivaGruposDefaultForm: AtividadeColetivaGruposFormModel = {
  tipoGrupo: TipoGrupoParticipanteAtividadeColetivaEnum.ATIVIDADE_EM_SAUDE,
} as Maybe<AtividadeColetivaGruposFormModel>

export const AtividadeColetivaGruposRegistrarView = () => {
  const { acesso } = useAcessoLotacaoOrEstagio()
  const { cachedValue, setCachedValue, clearCachedValue } = useAtividadeColetivaGruposCache()

  return (
    <Fragment>
      <Breadcrumb title='Criar grupo de atividade coletiva' />
      <PageContent type='filled' style={styles.pageContent}>
        <TitleGroup title='Criar grupo de atividade coletiva' style={styles.header} />
        <Grid gap={2}>
          <Cell size={10}>
            <Alert type='info' styles={{ container: styles.alert }}>
              Recomendamos utilizar essa funcionalidade para cadastrar grupos de atividade recorrentes com uma lista de
              participantes. Para atividades que não são frequentes, os participantes podem ser registrados diretamente
              no registro de atividade.
            </Alert>
          </Cell>
        </Grid>
        <AtividadeColetivaGruposForm
          unidadeSaudeNome={acesso.unidadeSaude.nome}
          initialValues={atividadeColetivaGruposDefaultForm}
          initialDirtyFields={cachedValue}
          setCachedValue={setCachedValue}
          clearCachedValue={clearCachedValue}
        />
      </PageContent>
    </Fragment>
  )
}

const styles = {
  header: css`
    margin-top: 1rem;
    margin-bottom: 2rem;
  `,
  pageContent: css`
    padding-bottom: 3.5rem;
  `,
  alert: css`
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
  `,
}
